(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (() => {
  const revealVideo = (video) => {
    if (video?.tagName !== 'VIDEO') return;
    const media = video.closest('.product-details deferred-media[autoplay]');
    if (!media || media.hasAttribute('data-video-playing')) return;

    if (typeof video.requestVideoFrameCallback === 'function') {
      if (media.hasAttribute('data-video-reveal-pending')) return;
      media.setAttribute('data-video-reveal-pending', '');
      video.requestVideoFrameCallback(() => {
        media.removeAttribute('data-video-reveal-pending');
        media.setAttribute('data-video-playing', '');
      });
    } else if (video.currentTime > 0.05) {
      media.setAttribute('data-video-playing', '');
    }
  };

  document.addEventListener('playing', (event) => revealVideo(event.target), true);
  document.addEventListener('timeupdate', (event) => revealVideo(event.target), true);

  const syncVideos = () => {
    document.querySelectorAll('.product-details deferred-media[autoplay] video').forEach((video) => {
      if (!video.paused && video.readyState >= 2) revealVideo(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVideos, { once: true });
  } else {
    syncVideos();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
